<template>
	<CRow>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2">
				فیلتر داده‌ها
			</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
                            <CCol sm="3">
                                <label>کاربر</label>
                                <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                </model-select>
                                <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                            </CCol>
                            <CCol sm="3">
                                <label>از تاریخ</label>
                                <date-picker placeholder="انتخاب کنید" v-model="form.sequence_start_from.val" type="datetime"></date-picker>
                                <small class="form-text text-muted w-100">{{form.sequence_start_from.inv}}</small>
                            </CCol>
                            <CCol sm="3">
                                <label>تا تاریخ</label>
                                <date-picker placeholder="انتخاب کنید" v-model="form.sequence_end_at.val" type="datetime"></date-picker>
                                <small class="form-text text-muted w-100">{{form.sequence_end_at.inv}}</small>
                            </CCol> 
                            <CCol sm="3">
                                <CInput v-model="form.every_n_minute.val" :description="form.every_n_minute.inv" dir="ltr" label="هر X دقیقه" />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="3">
                                <CInput v-model="form.every_n_minute_send_count.val" :description="form.every_n_minute_send_count.inv" dir="ltr" label="تعداد ارسال در هر X دقیقه" />
                            </CCol> 
                        </CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>روندها</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                        <template #sequence_is_start="data">
                            <td v-if="data.item.sequence_is_start">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
						<template #sequence_is_finished="data">
                            <td v-if="data.item.sequence_is_finished">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilListRich" size="lg"/>
                            </td>
                        </template>
						<template #action="data">
                            <td>
                                <template>
                                    <div class="flex-container">
                                        <div v-show="$store.state.perms.can_update_out_box_gradual_sms_send_sequences
                                            || $store.state.perms.can_update_out_box_gradual_sms_send_sequences_for_same_group_users
                                            || $store.state.perms.can_update_out_box_gradual_sms_send_sequences_for_all_users"
                                            @click="redirect_to(`/gradual/message/sequence/${data.item.id}/edit`)"
                                            v-c-tooltip.hover="'ویرایش'">
                                            <CIcon name="cilPencil" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_delete_out_box_gradual_sms_send_sequences
                                            || $store.state.perms.can_delete_out_box_gradual_sms_send_sequences_for_same_group_users
                                            || $store.state.perms.can_delete_out_box_gradual_sms_send_sequences_for_all_users"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
  </CRow>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'sequence_start_from', label: 'از تاریخ' },
                { key: 'sequence_end_at', label: 'تا تاریخ' },
                { key: 'every_n_minute', label: 'هر X دقیقه' },
                { key: 'every_n_minute_send_count', label: 'تعداد ارسال در هر X دقیقه' },
                { key: 'sequence_is_start', label: 'شروع روند' },
				{ key: 'sequence_is_finished', label: 'پایان روند' },
				{ key: 'sequence_last_send', label: 'تاریخ آخرین ارسال' },
				{ key: 'sequence_send_count', label: 'تعداد ارسال' },
				{ key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
                user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                sequence_start_from: {val: '', inv: '', v: { req: true, max: 16 }},
                sequence_end_at: {val: '', inv: '', v: { req: true, max: 16 }},
                every_n_minute: {val: '', inv: '', v: { req: true, max: 256 }},
                every_n_minute_send_count: {val: '', inv: '', v: { req: true, max: 256 }},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
            id: 0,
			users:[],
		}
	},
	watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
	mounted() {
		this.get();
		this.get_users();
	},
	methods: {
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}
				this.axios.get('out_box_gradual_sms_send_sequences/'
					+ '?count=1'
					+ '&gradual_sms_group_id=' + this.$route.params.id
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('out_box_gradual_sms_send_sequences/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ '&user_info=1' 
						+ '&gradual_sms_group_id=' + this.$route.params.id
						+ '&out_box_gradual_sms_group_info=1'
						+ filter)
						.then(res => {
							res.data.map(val =>{
								val.gradual_sms_group_name = val.out_box_gradual_sms_group_info.name;
								val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
								val.sequence_start_from = this.$moment(val.sequence_start_from, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								val.sequence_end_at = this.$moment(val.sequence_end_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								if(val.sequence_last_send == '0001-01-01T00:00:00Z'){
									val.sequence_last_send = '---';
								} else {
									val.sequence_last_send = this.$moment(val.sequence_last_send, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								}
							});
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('out_box_gradual_sms_send_sequences/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		},
		get_users(){
            this.axios.get('users/?type=view_out_box_gradual_sms_send_sequences')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_out_box_gradual_sms_send_sequence_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>